// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1WKbH","info":"UpdateTermsInfo_info__1DjfI"};